<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
  <div *ngIf="start$ | ngrxPush as start" fxLayout="column" class="time">
    <p class="mat-caption">
      {{ start | amDateFormat: dateFormat }}
      <ng-container *ngIf="end$ | ngrxPush as end">
        - {{ end | amDateFormat: dateFormat }}</ng-container
      >
    </p>

    <p *ngIf="duration$ | ngrxPush as duration" class="mat-caption">
      Duration: {{ duration }}
    </p>

    <p class="mat-caption">
      <ng-content select="pr-eventable-next-stage" />
    </p>
  </div>

  <ng-content select="[prEventableHeaderIcon]" />

  <div fxFlex fxLayout="column">
    <ng-container *ngIf="titleDirective; else defaultTitle">
      <ng-content select="[prEventableHeaderTitle]" />
    </ng-container>
    <ng-template #defaultTitle>
      <h3 class="mat-headline-6">{{ title }}</h3>
    </ng-template>

    <p class="mat-body-2">
      <ng-content />
    </p>
  </div>
</div>
